export enum UploadDocumentType {
  LetterOfAppointment = 1,
  SSMDocument = 2,
  OneTimeBusinessRegistration = 3,
}
